(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dialog = document.querySelector('[data-email-popup]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var STORAGE_KEY = 'lnd-email-popup-state';
    var scrollThreshold = parseFloat(dialog.dataset.triggerScroll || '40') / 100;
    var dwellMs         = parseInt(dialog.dataset.triggerDwellMs || '8000', 10);
    var cooldownMs      = parseInt(dialog.dataset.cooldownMs || '7200000', 10);  // 2h default
    var loadedAt = Date.now();

    function readState() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
      catch (e) { return null; }
    }
    function writeState(state) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ state: state, ts: Date.now() })); }
      catch (e) {}
    }
    function eligible() {
      var s = readState();
      if (!s) return true;
      if (s.state === 'submitted') return false;
      if (s.state === 'dismissed' && (Date.now() - (s.ts || 0)) < cooldownMs) return false;
      return true;
    }

    // Case 1: form just posted successfully — reopen and show the thank-you,
    // then auto-close so the homepage is unblocked.
    if (dialog.hasAttribute('data-just-submitted')) {
      writeState('submitted');
      try { dialog.showModal(); } catch (e) {}
      setTimeout(function () { try { dialog.close(); } catch (e) {} }, 2800);
      return;
    }

    if (!eligible()) return;

    // Case 2: scroll-and-dwell trigger.
    var opened = false;
    function tryOpen() {
      if (opened) return;
      if (Date.now() - loadedAt < dwellMs) return;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScroll <= 0) return;
      var pct = window.scrollY / maxScroll;
      if (pct >= scrollThreshold) {
        opened = true;
        try { dialog.showModal(); } catch (e) {}
      }
    }
    window.addEventListener('scroll', tryOpen, { passive: true });
    // Fallback nudge: once the dwell time is up, evaluate again (covers users
    // who scrolled past the threshold before the dwell timer expired).
    setTimeout(tryOpen, dwellMs + 50);

    // Dismissal: X button, ESC key (native), backdrop click.
    function markDismissed() { writeState('dismissed'); }
    dialog.addEventListener('close', markDismissed);
    var closeBtn = dialog.querySelector('[data-email-popup-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();      // click on the backdrop area, not the panel
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const toggle    = document.querySelector('[data-mobile-nav-toggle]');
    const drawer    = document.querySelector('[data-mobile-nav]');
    const closers   = document.querySelectorAll('[data-mobile-nav-close]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      closers.forEach(function (el) {
        if (el.classList.contains('mobile-drawer-backdrop')) {
          el.hidden = false;
          requestAnimationFrame(function () { el.classList.add('is-open'); });
        }
      });
      document.body.classList.add('mobile-nav-open');
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      closers.forEach(function (el) {
        if (el.classList.contains('mobile-drawer-backdrop')) {
          el.classList.remove('is-open');
          setTimeout(function () { el.hidden = true; }, 260);
        }
      });
      document.body.classList.remove('mobile-nav-open');
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) { close(); } else { open(); }
    });
    closers.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-video-player]').forEach(function (player) {
      var btn    = player.querySelector('[data-play-video]');
      var poster = player.querySelector('[data-poster]');
      var embed  = player.querySelector('[data-video-embed]');
      if (!btn || !poster || !embed) return;
      btn.addEventListener('click', function () {
        poster.hidden = true;
        embed.hidden = false;
        var iframe = embed.querySelector('[data-video-iframe]');
        if (iframe) iframe.src = iframe.getAttribute('data-src');
        var video = embed.querySelector('[data-video-el]');
        if (video) { video.play().catch(function(){}); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Hover magnifier — defers loading the 2000px-wide image until the first
    // mouseenter so it doesn't slow PDP load. On touch devices the lens is
    // already hidden via CSS; we also skip wiring listeners here.
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('[data-zoom-container]').forEach(function (container) {
      var lens = container.querySelector('[data-zoom-lens]');
      var src = container.getAttribute('data-zoom-src');
      if (!lens || !src) return;
      var loaded = false;
      container.addEventListener('mouseenter', function () {
        if (loaded) return;
        lens.style.backgroundImage = "url('" + src.replace(/'/g, "\\'") + "')";
        loaded = true;
      });
      container.addEventListener('mousemove', function (e) {
        var rect = container.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var pctX = Math.max(0, Math.min(100, (x / rect.width) * 100));
        var pctY = Math.max(0, Math.min(100, (y / rect.height) * 100));
        lens.style.left = x + 'px';
        lens.style.top = y + 'px';
        lens.style.backgroundPosition = pctX + '% ' + pctY + '%';
      });
      container.addEventListener('mouseleave', function () {
        lens.style.left = '-9999px';
        lens.style.top = '-9999px';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    // Mobile filter sheet — open/close from the toolbar "Filter" button, show
    // the active-filter count, and start collapsed so the sheet stays short.
    var sheet = document.getElementById('CollectionFilters');
    var toggle = document.querySelector('[data-filters-toggle]');
    if (!sheet || !toggle) return;
    var backdrop = document.querySelector('[data-filters-backdrop]');
    var countEl = toggle.querySelector('[data-filters-count]');
    var mq = window.matchMedia('(max-width: 768px)');

    function activeCount() {
      var n = sheet.querySelectorAll('input[type="checkbox"]:checked').length;
      var price = Array.prototype.some.call(
        sheet.querySelectorAll('.collection__filter-price input'),
        function (i) { return i.value !== ''; }
      );
      return n + (price ? 1 : 0);
    }
    function renderCount() {
      if (!countEl) return;
      var n = activeCount();
      countEl.textContent = n || '';
      countEl.hidden = !n;
    }
    function open() {
      sheet.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      sheet.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (backdrop) backdrop.addEventListener('click', close);
    sheet.querySelectorAll('[data-filters-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
    });
    sheet.addEventListener('change', renderCount);
    if (mq.addEventListener) mq.addEventListener('change', function (e) { if (!e.matches) close(); });

    // After the tag-filter script below restores ?filters= state: collapse
    // unused groups on mobile and show the count.
    setTimeout(function () {
      if (mq.matches) {
        sheet.querySelectorAll('details.collection__filter').forEach(function (d) {
          var inUse = d.querySelector('input[type="checkbox"]:checked') ||
            Array.prototype.some.call(d.querySelectorAll('input[type="number"]'), function (i) { return i.value !== ''; });
          if (!inUse) d.removeAttribute('open');
        });
      }
      renderCount();
    }, 0);
  })();

  (function () {
    // Multi-group sidebar filters — OR within a group, AND across groups.
    // Each card carries data-filters="benefit:k1 benefit:k2 protein:k3 ...".
    // URL-synced via ?filters=group:key,group:key so filtered views are
    // shareable / bookmarkable / back-button friendly.
    var grid = document.querySelector('[data-collection-grid]');
    if (!grid) return;
    var checkboxes = document.querySelectorAll('[data-filter-group][data-filter-key]');
    if (!checkboxes.length) return;
    var items = grid.querySelectorAll('.collection__grid-item');
    var countEl = document.querySelector('[data-collection-count]');
    var defaultText = countEl ? (countEl.getAttribute('data-default-text') || countEl.textContent) : '';
    var total = items.length;
    var selected = {};                                            // { group: Set(keys) }

    function syncFromURL() {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('filters');
      selected = {};
      if (raw) {
        raw.split(',').filter(Boolean).forEach(function (token) {
          var idx = token.indexOf(':');
          if (idx < 1) return;
          var g = token.slice(0, idx), k = token.slice(idx + 1);
          if (!selected[g]) selected[g] = new Set();
          selected[g].add(k);
        });
      }
    }

    function syncURL() {
      var url = new URL(window.location.href);
      var tokens = [];
      Object.keys(selected).forEach(function (g) {
        selected[g].forEach(function (k) { tokens.push(g + ':' + k); });
      });
      var paramValue = tokens.join(',');
      if (tokens.length === 0) {
        url.searchParams.delete('filters');
      } else {
        url.searchParams.set('filters', paramValue);
      }
      window.history.replaceState({}, '', url.toString());
      // Mirror into the hidden input inside #CollectionFilterForm so a native
      // Apply (Availability / Price) form-GET preserves ?filters= in the URL.
      var hidden = document.querySelector('[data-filters-hidden]');
      if (hidden) hidden.value = paramValue;
    }

    function applyFilter() {
      var activeGroups = Object.keys(selected).filter(function (g) {
        return selected[g] && selected[g].size > 0;
      });
      var anyActive = activeGroups.length > 0;
      var shown = 0;
      items.forEach(function (item) {
        var itemTags = (item.dataset.filters || '').split(/\s+/).filter(Boolean);
        // AND across groups: every active group needs at least one matching tag.
        // OR within group: ANY of the selected keys in that group is enough.
        var matchAll = activeGroups.every(function (g) {
          var keys = selected[g];
          return itemTags.some(function (tag) {
            var idx = tag.indexOf(':');
            return idx > 0 && tag.slice(0, idx) === g && keys.has(tag.slice(idx + 1));
          });
        });
        var visible = !anyActive || matchAll;
        item.hidden = !visible;
        if (visible) shown++;
      });
      // Reflect selected state on checkboxes (covers URL-restore on page load).
      checkboxes.forEach(function (cb) {
        var g = cb.dataset.filterGroup;
        var k = cb.dataset.filterKey;
        cb.checked = !!(selected[g] && selected[g].has(k));
      });
      if (countEl) {
        countEl.textContent = anyActive
          ? (shown + ' of ' + total + ' shown')
          : defaultText;
      }
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        var g = cb.dataset.filterGroup;
        var k = cb.dataset.filterKey;
        if (!selected[g]) selected[g] = new Set();
        if (cb.checked) selected[g].add(k); else selected[g].delete(k);
        syncURL();
        applyFilter();
      });
    });

    syncFromURL();
    applyFilter();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('.product-v2') || document.querySelector('.product-v2');
    if (!root) return;

    // Gallery thumbnails
    const thumbs = root.querySelectorAll('[data-thumb]');
    const slides = root.querySelectorAll('[data-media-id]');
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        const id = t.dataset.thumb;
        thumbs.forEach(x => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        slides.forEach(s => s.classList.toggle('is-active', s.dataset.mediaId === id));
      });
    });

    // Qty stepper (single-variant products only)
    root.querySelectorAll('[data-qty-step]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const container = btn.closest('[data-qty]') || btn.parentElement;
        const input = container.querySelector('input[name="quantity"]');
        if (!input) return;
        const step = parseInt(btn.dataset.qtyStep, 10);
        const next = Math.max(1, parseInt(input.value || '1', 10) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Pack selector — switch active variant; update price, discount %, savings line, button price.
    const packs = root.querySelectorAll('[data-pack]');
    const idInput = root.querySelector('[data-variant-id-input]');
    const priceValue = root.querySelector('[data-price-value]');
    const priceCompare = root.querySelector('[data-price-compare]');
    const priceOff = root.querySelector('[data-price-off]');
    const priceMeta = root.querySelector('[data-price-meta]');
    const addPrice = root.querySelector('[data-add-price]');
    const rupees = (paise) => Math.round(parseInt(paise, 10) / 100);
    packs.forEach(pack => {
      pack.addEventListener('click', () => {
        if (pack.getAttribute('aria-disabled') === 'true') return;
        packs.forEach(x => {
          const on = x === pack;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        const price = rupees(pack.dataset.price);
        const size = parseInt(pack.dataset.packsize || '1', 10);
        const off = parseInt(pack.dataset.off || '0', 10);
        const compare = pack.dataset.compare ? rupees(pack.dataset.compare) : null;
        if (idInput) idInput.value = pack.dataset.variantId;
        if (priceValue) priceValue.textContent = '₹' + price;
        if (priceCompare) {
          if (compare) { priceCompare.textContent = '₹' + compare; priceCompare.hidden = false; }
          else { priceCompare.hidden = true; }
        }
        if (priceOff) {
          if (off > 0) { priceOff.textContent = off + '% off'; priceOff.hidden = false; }
          else { priceOff.hidden = true; }
        }
        if (priceMeta) {
          if (size > 1 && compare) {
            priceMeta.textContent = '₹' + Math.round(price / size) + ' per pouch · You save ₹' + (compare - price);
            priceMeta.hidden = false;
          } else { priceMeta.hidden = true; }
        }
        if (addPrice) addPrice.textContent = '· ₹' + price;
      });
    });

    // Pincode delivery check — uses free api.postalpincode.in endpoint.
    const pinCheck = root.querySelector('[data-pincode-check]');
    if (pinCheck) {
      const form = pinCheck.querySelector('[data-pincode-form]');
      const input = form.querySelector('input[name="pincode"]');
      const submitBtn = form.querySelector('.product-v2__pincode-submit');
      const result = pinCheck.querySelector('[data-pincode-result]');
      const mumbaiOnly = pinCheck.dataset.mumbaiOnly === 'true';

      const show = (msg, tone) => {
        result.textContent = msg;
        result.className = 'product-v2__pincode-result product-v2__pincode-result--' + tone;
      };

      const updateBtnState = () => {
        const valid = /^[0-9]{6}$/.test((input.value || '').trim());
        submitBtn.classList.toggle('is-active', valid);
      };
      input.addEventListener('input', updateBtnState);
      input.addEventListener('change', updateBtnState);

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const pin = (input.value || '').trim();
        if (!/^[0-9]{6}$/.test(pin)) {
          show('Please enter a valid 6-digit PIN.', 'error');
          return;
        }
        show('Checking…', 'loading');
        try {
          const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
          const data = await res.json();
          const po = data && data[0] && data[0].PostOffice && data[0].PostOffice[0];
          if (!po) {
            show('Invalid PIN code. Please check and try again.', 'error');
            return;
          }
          const city = (po.District || '').toLowerCase().trim();
          const state = po.State || '';
          const isMumbai = /mumbai|navi mumbai|thane/.test(city);

          if (mumbaiOnly) {
            if (isMumbai) {
              show(`✓ Same-day delivery available in ${po.District}, ${state}.`, 'ok');
            } else {
              show(`✗ This product is currently Mumbai-only. (You're in ${po.District}, ${state}.)`, 'error');
            }
          } else {
            if (isMumbai) {
              show(`✓ Delivers to ${po.District}, ${state} in 1–2 business days.`, 'ok');
            } else {
              show(`✓ Delivers to ${po.District}, ${state} in 3–5 business days.`, 'ok');
            }
          }
        } catch (err) {
          show('Could not check right now. Please try again or WhatsApp us.', 'error');
        }
      });
    }

    // ── Mumbai-only PIN gate (Bone Broth) ──
    // Blocks every add-to-cart entry point on the page until the shopper confirms a
    // Mumbai / Navi Mumbai / Thane PIN. Runs at document capture so it fires BEFORE
    // the Assortion cart app intercepts the submit.
    if (root && root.dataset.mumbaiGate === 'true') {
      const modal = document.querySelector('[data-mumbai-gate-modal]');
      const gForm = modal && modal.querySelector('[data-mumbai-gate-form]');
      const gInput = gForm && gForm.querySelector('input[name="pincode"]');
      const gResult = modal && modal.querySelector('[data-mumbai-gate-result]');
      const SS_KEY = 'ld_bonebroth_pin_ok';
      let pendingForm = null;
      const isConfirmed = () => { try { return sessionStorage.getItem(SS_KEY) === '1'; } catch (e) { return false; } };
      const openGate = () => { if (!modal) return; modal.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => gInput && gInput.focus(), 60); };
      const closeGate = () => { if (!modal) return; modal.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
      const gShow = (msg, tone) => { if (gResult) { gResult.textContent = msg; gResult.className = 'mumbai-gate__result' + (tone ? ' mumbai-gate__result--' + tone : ''); } };

      if (modal) {
        modal.querySelectorAll('[data-mumbai-gate-close]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); closeGate(); }));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeGate(); });
      }

      // Intercept add-to-cart clicks (main CTA, sticky bar, cta-checkout) before Assortion.
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.product-v2__add, .sticky-buy__cta, .cta-checkout__add');
        if (!btn) return;
        const f = btn.closest('form[action*="/cart/add"]');
        if (!f) return;                  // ignore non-form CTAs (e.g. cta-checkout fallback link)
        if (isConfirmed()) return;        // already verified this session → let it through
        e.preventDefault();
        e.stopImmediatePropagation();     // block Assortion + native submit
        pendingForm = f;
        gShow('', '');
        if (gInput) gInput.value = '';
        openGate();
      }, true);

      if (gForm) {
        gForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          const pin = (gInput.value || '').trim();
          if (!/^[0-9]{6}$/.test(pin)) { gShow('Please enter a valid 6-digit PIN.', 'error'); return; }
          gShow('Checking…', 'loading');
          try {
            const res = await fetch('https://api.postalpincode.in/pincode/' + pin);
            const data = await res.json();
            const po = data && data[0] && data[0].PostOffice && data[0].PostOffice[0];
            if (!po) { gShow('Invalid PIN code. Please check and try again.', 'error'); return; }
            const city = (po.District || '').toLowerCase().trim();
            const isMumbai = /mumbai|navi mumbai|thane/.test(city);
            if (isMumbai) {
              try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) {}
              gShow('✓ We deliver to ' + po.District + '. Adding to your cart…', 'ok');
              const f = pendingForm;
              setTimeout(() => { closeGate(); if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); } }, 650);
            } else {
              gShow('Sorry — we currently ship Bone Broth to Mumbai only. (Your PIN is in ' + po.District + '.)', 'error');
            }
          } catch (err) {
            gShow('Could not verify right now. Please try again, or WhatsApp us.', 'error');
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-review-slider]').forEach(function (root) {
      var items = root.querySelectorAll('.review-slider__item');
      var dots  = root.querySelectorAll('[data-review-dot]');
      if (items.length < 2) return;

      var current = 0;
      var timer;
      var interval = 4500;
      var animating = false;

      function show(newIndex, direction) {
        if (animating) return;
        direction = direction || 1;
        newIndex = (newIndex + items.length) % items.length;
        if (newIndex === current) return;
        animating = true;

        var outgoing = items[current];
        var incoming = items[newIndex];

        // Clear any stale classes
        items.forEach(function (it) {
          it.classList.remove('is-leaving-left', 'is-leaving-right', 'is-prep-left');
        });

        if (direction > 0) {
          // Forward: outgoing slides out left, incoming comes in from right (default transform)
          outgoing.classList.remove('is-active');
          outgoing.classList.add('is-leaving-left');
        } else {
          // Backward: outgoing slides out right, incoming needs to be pre-positioned on the left
          outgoing.classList.remove('is-active');
          outgoing.classList.add('is-leaving-right');
          incoming.classList.add('is-prep-left');
          // Force reflow so the prep transform applies instantly before we animate
          incoming.offsetHeight;
          incoming.classList.remove('is-prep-left');
        }

        // Animate incoming into center on next frame
        requestAnimationFrame(function () {
          incoming.classList.add('is-active');
        });

        // Update dots
        if (dots[current]) dots[current].classList.remove('is-active');
        if (dots[newIndex]) dots[newIndex].classList.add('is-active');

        current = newIndex;

        // Release lock after the transition duration
        setTimeout(function () { animating = false; }, 560);
      }
      function next() { show(current + 1,  1); }
      function prev() { show(current - 1, -1); }

      function start() { stop(); timer = setInterval(next, interval); }
      function stop()  { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.getAttribute('data-review-dot'), 10);
          show(i);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      // Swipe support (touch devices)
      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var touchDeltaY = 0;
      var isSwiping = false;

      root.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        touchDeltaY = 0;
        isSwiping = true;
        stop();
      }, { passive: true });

      root.addEventListener('touchmove', function (e) {
        if (!isSwiping || !e.touches || e.touches.length !== 1) return;
        touchDeltaX = e.touches[0].clientX - touchStartX;
        touchDeltaY = e.touches[0].clientY - touchStartY;
      }, { passive: true });

      root.addEventListener('touchend', function () {
        if (!isSwiping) return;
        isSwiping = false;
        // Only treat as a swipe if horizontal movement dominates and is significant.
        if (Math.abs(touchDeltaX) > 40 && Math.abs(touchDeltaX) > Math.abs(touchDeltaY)) {
          if (touchDeltaX < 0) next(); else prev();
        }
        start();
      });

      // Pause when off-screen, run when in view. Also start() immediately so
      // carousels above the fold don't wait for scroll.
      start();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.2 });
        io.observe(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy-bar"]) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;

    function findMainCta() { return document.querySelector('.product-v2__add'); }
    function isInViewport(el) {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    function update() {
      const cta = findMainCta();
      // If we can't find the main CTA at all, show the bar once the user has
      // scrolled past the header area so they always have a way to buy on mobile.
      if (!cta) {
        bar.classList.toggle('is-visible', window.scrollY > 500);
        return;
      }
      bar.classList.toggle('is-visible', !isInViewport(cta));
    }

    // Belt + suspenders: use IntersectionObserver (cheap, accurate) AND a throttled
    // scroll listener (fires even if the observer gets detached by AJAX re-renders).
    const mainCta = findMainCta();
    if (mainCta && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => bar.classList.toggle('is-visible', !e.isIntersecting));
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      io.observe(mainCta);
    }

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Run once on load so the initial state is correct.
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mediaEls = document.querySelectorAll('.reels__media[data-reel]');
    mediaEls.forEach(function (el) {
      const video = el.querySelector('[data-reel-video]');
      const btn = el.querySelector('[data-reel-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (video) {
          video.muted = false;
          video.play();
          el.classList.add('is-playing');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
